import { checkUserLoggedIn, removeTokenFromBrowser } from '../../auth/sso';

// eslint-disable-next-line import/prefer-default-export
export const updateLogoutStateIfRequired = async (productToken, dispatch) => {
    if (!productToken) {
        removeTokenFromBrowser();
        dispatch({ type: 'logout' });
    }

    const isUserLoggedIn = await checkUserLoggedIn(productToken);
    if (!isUserLoggedIn) {
        removeTokenFromBrowser();
        dispatch({ type: 'logout' });
    }
};
